export default {
  required: "Kötelező",
  validPercentageRequired: "Kérem adjon meg 0% és 100% közötti értéket.",
  typeRequired: "Kérem válasszon ki egy típust.",
  passwordMismatch: "Nem egyezik meg a jelszóval!",
  fullName: {
    minLength: "A névnek minimum 6 karakter hosszúnak kell lennie.",
    fullName: "A teljes nevét kell megadnia.",
    maxLength: "A név maximum 32 karakter hosszú lehet."
  },
  invalidValue: "Érvénytelen érték.",
  invalidPostalCode: "Érvénytelen irányítószám",
  invalidWeight: "Érvénytelen testsúly.",
  invalidInhibitorUnit: "Érvénytelen gátlótest mennyiség",
  invalidPhoneNo: 'Érvénytelen telefonszám. Formátum: 2012345678',
  invalidEmail: 'Érvénytelen e-mail cím.',
  invalidDate: 'Érvénytelen dátum. Formátum: ÉÉÉÉ-HH-NN',
  invalidCalendarDate: 'Ez a dátum nem létezik a naptárban.',
  password: {
    missingUppercase: "Jelszavának legalább egy nagybetűt kell tartalmaznia.",
    missingLowercase: "Jelszavának legalább egy kisbetűt kell tartalmaznia.",
    missingNumber: "Jelszavának legalább egy számot kell tartalmaznia.",
    missingSpecial: "Jelszavának legalább egy speciális karaktert kell tartalmaznia.",
    minLength: "Jelszava legalább 8 karakter hosszú kell, hogy legyen.",
    confirmMismatch: "A jelszavak nem egyeznek!"
  },
  dateHint: "Formátum: ÉÉÉÉ-HH-NN"
}
